export const features = [
    {
        title: 'features.display.title',
        description: 'features.display.content',
        image: 'assets/images/advantage/displayYourVideo.png',
        mouseOn : false,
        selected : true,
        iconActived : 'assets/images/svg/icon_pc-yellow.svg',
        iconDeactived : 'assets/images/svg/icon_pc-grey.svg'
    },
    {
        title: 'features.training.title',
        description: 'features.training.content',
        image: 'assets/images/get-started/discover-the-training-features/Visuel-duo-Site-web.jpg',
        mouseOn : false,
        selected : false,
        iconActived : 'assets/images/svg/icon_cup-yellow.svg',
        iconDeactived : 'assets/images/svg/icon_cup-grey.svg'
    },
    {
        title: 'features.share.title',
        description: 'features.share.content',
        image: 'assets/images/advantage/shareYourSession.jpg',
        mouseOn : false,
        selected : false,
        iconActived : 'assets/images/svg/icon_share-yellow.svg',
        iconDeactived : 'assets/images/svg/icon_share-grey.svg'
    },
    {
        title: 'features.download.title',
        description: 'features.download.content',
        image: 'assets/images/get-started/discover-the-training-features/Visuel-Charlotte-Site-Web.jpg',
        mouseOn : false,
        selected : false,
        iconActived : 'assets/images/svg/icon_download-yellow.svg',
        iconDeactived : 'assets/images/svg/icon_download-grey.svg'
    }
  ];

export const featuresVideo = [
  {
    title: 'homepage.carousel.motion.title',
    description: 'homepage.carousel.motion.text',
    name: 'motionVideo_v3',
    mouseOn: false,
    selected: true,
    iconActived: 'assets/images/svg/video_icon_yellow.svg',
    iconDeactived: 'assets/images/svg/video_icon_grey.svg',
  },
  {
    title: 'homepage.carousel.coaching.title',
    description: 'homepage.carousel.coaching.text',
    name: 'coachingVideo_v3',
    mouseOn: false,
    selected: false,
    iconActived: 'assets/images/svg/coaching_icon_yellow.svg',
    iconDeactived: 'assets/images/svg/coaching_icon_grey.svg',
  },
  {
    title: 'homepage.carousel.multiplayer.title',
    description: 'homepage.carousel.multiplayer.text',
    name: 'multiplayer_v3',
    mouseOn: false,
    selected: false,
    iconActived: 'assets/images/svg/multi_icon_yellow.svg',
    iconDeactived: 'assets/images/svg/multi_icon_grey.svg',
  },
  {
    title: 'homepage.carousel.freeRide.title',
    description: 'homepage.carousel.freeRide.text',
    name: 'freeRide_v3',
    mouseOn: false,
    selected: false,
    iconActived: 'assets/images/svg/freeride_icon_yellow.svg',
    iconDeactived: 'assets/images/svg/freeride_icon_grey.svg',
  },
  {
    title: 'homepage.carousel.workout.title',
    description: 'homepage.carousel.workout.text',
    name: 'structWorkout_v4',
    mouseOn: false,
    selected: false,
    iconActived: 'assets/images/svg/interval_icon_yellow.svg',
    iconDeactived: 'assets/images/svg/interval_icon_grey.svg',
  },
  {
    title: 'homepage.carousel.map.title',
    description: 'homepage.carousel.map.text',
    name: 'mapMode_v1',
    mouseOn: false,
    selected: false,
    iconActived: 'assets/images/svg/gps_icon_yellow.svg',
    iconDeactived: 'assets/images/svg/gps_icon_grey.svg',
  },
];
